export default {
  tiles: [
    {
      title: 'Nerdy Culture',
      titleSize: '3',
      value:
        "We're always creating new and exciting ways to invest in Nerds and encourage career development. Things like quarterly hackathons, exclusive NerdTalks and orientation and management courses help us grow both personally and professionally.",
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Healthy Living',
      titleSize: '3',
      value:
        'Our benefits package includes 100% paid medical, dental, vision, life and disability plans for Nerds and their dependents. Plus, on-site fitness and meditation classes, healthy meals and a generous wellness/gym subsidy keep our Nerds feeling rejuvenated.',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Money Smart',
      titleSize: '3',
      value:
        'We like to talk money (shocking, we know). And that includes transparency around all aspects of our business - including our financial performance. We also offer competitive employee compensation, equity, 401(k) matching and cash to cover your commute.',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Work Life Balance',
      titleSize: '3',
      value:
        'Never worry about finding time for hobbies or stepping away from your desk (for vacation, a new baby or the sniffles). We offer unlimited paid time off, 100% paid parental leave and plenty of opportunities to give back and have fun.',
      columnClass: 'matrix-2-col__tile',
    },
  ],
};
